export const CONNECTION_ROW_MENU_ITEMS = [
  { id: 'connection-nickname', label: 'Set nickname' },
  { id: 'connection-share', label: 'Share' },
  { id: 'connection-permissions', label: 'Tool permissions' },
  { id: 'connection-reauthenticate', label: 'Re-authorize' },
  { id: 'connection-remove', label: 'Remove from agent', showDividerBefore: true },
  { id: 'connection-delete', label: 'Delete', variant: 'danger' },
]

export const SETTINGS_CONNECTION_ROW_MENU_ITEMS = [
  { id: 'connection-permissions', label: 'Tool permissions' },
  { id: 'connection-reauthenticate', label: 'Reconnect' },
  { id: 'connection-remove', label: 'Disconnect', variant: 'danger' },
]
